import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Event sent when a user views a board',
  name: 'Viewed board',
  params: [
    {
      description: 'The id of the board',
      name: 'board_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The title of the board',
      name: 'board_title',
      required: true,
      type: 'string',
    },
    {
      description: 'The view type of the board',
      name: 'board_view',
      required: false,
      type: 'enum',
      values: ['kanban', 'gallery', 'table'],
    },
  ],
};

export default META;
